import { render, staticRenderFns } from "./currency-text-field.vue?vue&type=template&id=28775c12&"
import script from "./currency-text-field.vue?vue&type=script&lang=js&"
export * from "./currency-text-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports